define.alias("shared/components/shared/post/secondary/hashtag-suggestions/item", "calendar/components/shared/post/secondary/hashtag-suggestions/item");